import styled from 'styled-components';

export default styled.div`
  min-height: 100vh;
  background: #0f1123;
  padding: 2em;

  @media (max-width: 768px) {
    padding: 1em;
  }

  .doc--header {
    max-width: 1200px;
    margin: 0 auto 3em;
    text-align: center;

    .back--button {
      display: inline-flex;
      align-items: center;
      gap: 0.5em;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      padding: 0.75em 1.5em;
      border-radius: 8px;
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.95rem;
      cursor: pointer;
      transition: all 0.3s ease;
      margin-bottom: 2em;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: ${({ theme }) => theme.primary};
      }
    }

    .download--button {
      display: inline-flex;
      align-items: center;
      gap: 0.5em;
      background: ${({ theme }) => theme.primary};
      border: none;
      padding: 1em 2em;
      border-radius: 8px;
      color: #fff;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      margin-top: 2em;
      box-shadow: 0 4px 12px rgba(254, 125, 17, 0.3);

      &:hover {
        background: ${({ theme }) => theme.primaryDark || '#d96f0c'};
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(254, 125, 17, 0.4);
      }

      svg {
        font-size: 1.2em;
      }
    }

    h1 {
      font-size: 3rem;
      color: #fff;
      margin-bottom: 0.5em;
      background: linear-gradient(135deg, #fff 0%, ${({ theme }) => theme.primary} 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;

      @media (max-width: 768px) {
        font-size: 2rem;
      }
    }

    p {
      font-size: 1.2rem;
      color: rgba(255, 255, 255, 0.7);
      max-width: 700px;
      margin: 0 auto;

      @media (max-width: 768px) {
        font-size: 1rem;
      }
    }
  }

  .main--tabs {
    max-width: 1200px;
    margin: 0 auto 2em;
    display: flex;
    gap: 1em;
    justify-content: center;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 0;

    @media (max-width: 768px) {
      gap: 0.5em;
    }

    .main--tab {
      padding: 1.25em 2.5em;
      background: transparent;
      border: none;
      border-bottom: 3px solid transparent;
      color: rgba(255, 255, 255, 0.6);
      font-weight: 700;
      font-size: 1.1rem;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;

      @media (max-width: 768px) {
        padding: 1em 1.5em;
        font-size: 0.95rem;
      }

      &:hover {
        color: rgba(255, 255, 255, 0.9);
        background: rgba(255, 255, 255, 0.03);
      }

      &.active {
        color: ${({ theme }) => theme.primary};
        border-bottom-color: ${({ theme }) => theme.primary};
        background: rgba(254, 125, 17, 0.05);
      }
    }
  }

  .doc--content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 3em;

    @media (max-width: 768px) {
      gap: 2em;
    }
  }

  .doc--section {
    background: #1a1d35;
    border-radius: 16px;
    padding: 2.5em;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    @media (max-width: 768px) {
      padding: 1.5em;
      border-radius: 12px;
    }

    h2 {
      font-size: 2rem;
      color: #fff;
      margin-bottom: 1em;
      display: flex;
      align-items: center;
      gap: 0.5em;

      @media (max-width: 768px) {
        font-size: 1.5rem;
      }
    }

    h4 {
      font-size: 1.2rem;
      color: ${({ theme }) => theme.primary};
      margin: 1.5em 0 1em;
    }

    p {
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.8;
      margin-bottom: 1em;
      font-size: 1.05rem;
    }
  }

  .code--block {
    position: relative;
    background: #0d0f1f;
    border: 1px solid rgba(254, 125, 17, 0.2);
    border-radius: 8px;
    padding: 1.5em;
    margin: 1em 0;
    overflow-x: auto;

    @media (max-width: 768px) {
      padding: 1em;
    }

    pre {
      margin: 0;
      color: #fff;
      font-family: 'Courier New', monospace;
      font-size: 0.9rem;
      line-height: 1.6;
      overflow-x: auto;

      @media (max-width: 768px) {
        font-size: 0.8rem;
      }
    }

    code {
      color: ${({ theme }) => theme.primary};
      font-family: 'Courier New', monospace;
    }

    .copy--btn {
      position: absolute;
      top: 1em;
      right: 1em;
      background: rgba(254, 125, 17, 0.2);
      border: 1px solid rgba(254, 125, 17, 0.4);
      padding: 0.5em 0.75em;
      border-radius: 6px;
      color: ${({ theme }) => theme.primary};
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: rgba(254, 125, 17, 0.3);
      }
    }
  }

  .info--box {
    background: rgba(254, 125, 17, 0.1);
    border-left: 4px solid ${({ theme }) => theme.primary};
    padding: 1em 1.5em;
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.9);
    margin: 1.5em 0;
  }

  .endpoint {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 2em;
    margin: 2em 0;

    @media (max-width: 768px) {
      padding: 1.25em;
    }

    .endpoint--header {
      display: flex;
      align-items: center;
      gap: 1em;
      margin-bottom: 1em;
      flex-wrap: wrap;

      .method {
        padding: 0.5em 1em;
        border-radius: 6px;
        font-weight: 700;
        font-size: 0.85rem;
        text-transform: uppercase;

        &.post {
          background: rgba(76, 175, 80, 0.2);
          color: #81C784;
        }

        &.get {
          background: rgba(33, 150, 243, 0.2);
          color: #64B5F6;
        }

        &.put {
          background: rgba(255, 152, 0, 0.2);
          color: #FFB74D;
        }

        &.delete {
          background: rgba(244, 67, 54, 0.2);
          color: #E57373;
        }
      }

      .path {
        color: ${({ theme }) => theme.primary};
        font-family: 'Courier New', monospace;
        font-size: 1.1rem;
        font-weight: 600;

        @media (max-width: 768px) {
          font-size: 0.95rem;
        }
      }
    }
  }

  .field--list {
    list-style: none;
    padding: 0;
    margin: 1em 0;

    li {
      padding: 0.75em 0;
      color: rgba(255, 255, 255, 0.8);
      border-bottom: 1px solid rgba(255, 255, 255, 0.05);

      &:last-child {
        border-bottom: none;
      }

      code {
        color: ${({ theme }) => theme.primary};
        background: rgba(254, 125, 17, 0.1);
        padding: 0.25em 0.5em;
        border-radius: 4px;
        font-family: 'Courier New', monospace;
        font-size: 0.9rem;
      }
    }
  }

  .status--list {
    display: flex;
    flex-direction: column;
    gap: 1em;
  }

  .status--item {
    display: flex;
    align-items: center;
    gap: 1.5em;
    padding: 1em;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5em;
    }

    .status--badge {
      padding: 0.5em 1em;
      border-radius: 20px;
      font-weight: 600;
      font-size: 0.85rem;
      white-space: nowrap;

      &.pending {
        background: rgba(255, 193, 7, 0.2);
        color: #FFD54F;
      }

      &.assigned {
        background: rgba(33, 150, 243, 0.2);
        color: #64B5F6;
      }

      &.picked {
        background: rgba(156, 39, 176, 0.2);
        color: #BA68C8;
      }

      &.transit {
        background: rgba(254, 125, 17, 0.2);
        color: ${({ theme }) => theme.primary};
      }

      &.delivered {
        background: rgba(76, 175, 80, 0.2);
        color: #81C784;
      }

      &.cancelled {
        background: rgba(244, 67, 54, 0.2);
        color: #E57373;
      }
    }

    span:last-child {
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .language--tabs {
    display: flex;
    gap: 0.5em;
    margin-bottom: 1.5em;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    overflow-x: auto;

    .lang--tab {
      padding: 1em 1.5em;
      background: transparent;
      border: none;
      border-bottom: 3px solid transparent;
      color: rgba(255, 255, 255, 0.6);
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;

      @media (max-width: 768px) {
        padding: 0.75em 1em;
        font-size: 0.9rem;
      }

      &:hover {
        color: rgba(255, 255, 255, 0.9);
      }

      &.active {
        color: ${({ theme }) => theme.primary};
        border-bottom-color: ${({ theme }) => theme.primary};
      }
    }
  }

  .code--example {
    margin-bottom: 2em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .best--practices {
    list-style: none;
    counter-reset: practice-counter;
    padding: 0;

    li {
      counter-increment: practice-counter;
      position: relative;
      padding: 1.5em 1.5em 1.5em 4em;
      background: rgba(255, 255, 255, 0.03);
      border-radius: 8px;
      margin-bottom: 1em;

      @media (max-width: 768px) {
        padding: 1.25em 1.25em 1.25em 3.5em;
      }

      &:before {
        content: counter(practice-counter);
        position: absolute;
        left: 1.5em;
        top: 1.5em;
        width: 2em;
        height: 2em;
        background: ${({ theme }) => theme.primary};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        color: #fff;

        @media (max-width: 768px) {
          width: 1.75em;
          height: 1.75em;
          left: 1.25em;
          font-size: 0.9rem;
        }
      }

      strong {
        display: block;
        color: #fff;
        font-size: 1.1rem;
        margin-bottom: 0.5em;

        @media (max-width: 768px) {
          font-size: 1rem;
        }
      }

      p {
        color: rgba(255, 255, 255, 0.7);
        margin: 0;
        font-size: 0.95rem;
      }
    }
  }

  .support--section {
    text-align: center;
    background: linear-gradient(135deg, rgba(254, 125, 17, 0.1) 0%, rgba(254, 125, 17, 0.05) 100%);
    border: 2px solid rgba(254, 125, 17, 0.3);

    h2 {
      justify-content: center;
    }

    .support--links {
      display: flex;
      gap: 1.5em;
      justify-content: center;
      margin-top: 2em;
      flex-wrap: wrap;

      @media (max-width: 768px) {
        flex-direction: column;
        gap: 1em;
      }

      .support--link {
        padding: 1em 2em;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
        color: #fff;
        text-decoration: none;
        font-weight: 600;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          background: rgba(255, 255, 255, 0.15);
          transform: translateY(-2px);
        }
      }
    }
  }

  .params--table {
    width: 100%;
    border-collapse: collapse;
    margin: 1.5em 0;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;
    overflow: hidden;

    thead {
      background: rgba(254, 125, 17, 0.1);
      
      tr {
        th {
          padding: 1em 1.5em;
          text-align: left;
          color: ${({ theme }) => theme.primary};
          font-weight: 700;
          font-size: 0.95rem;
          border-bottom: 2px solid rgba(254, 125, 17, 0.3);

          @media (max-width: 768px) {
            padding: 0.75em 1em;
            font-size: 0.85rem;
          }
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);

        &:last-child {
          border-bottom: none;
        }

        td {
          padding: 1em 1.5em;
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.95rem;

          @media (max-width: 768px) {
            padding: 0.75em 1em;
            font-size: 0.85rem;
          }

          code {
            color: ${({ theme }) => theme.primary};
            background: rgba(254, 125, 17, 0.1);
            padding: 0.25em 0.5em;
            border-radius: 4px;
            font-family: 'Courier New', monospace;
            font-size: 0.9rem;
          }
        }
      }
    }
  }

  .embed--preview {
    margin: 2em 0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    border: 2px solid rgba(254, 125, 17, 0.2);
  }

  .feature--list {
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1em;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }

    li {
      padding: 1em 1.5em;
      background: rgba(255, 255, 255, 0.03);
      border-radius: 8px;
      color: rgba(255, 255, 255, 0.8);
      border-left: 4px solid ${({ theme }) => theme.primary};

      strong {
        color: #fff;
        display: block;
        margin-bottom: 0.25em;
      }
    }
  }

  .doc--section h3 {
    font-size: 1.5rem;
    color: #fff;
    margin: 2em 0 1em;
    padding-bottom: 0.5em;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);

    @media (max-width: 768px) {
      font-size: 1.25rem;
    }
  }
`;
